/** 系统级：约束 thinking/reasoning 语言 */
export const ZZL_THINKING_SYSTEM_HINT =
  '你必须使用中文进行思考（reasoning/thinking 过程只能使用中文，禁止用英文思考）。';

/** 用户消息开头：再次强调 */
export const ZZL_THINKING_PROMPT_HINT =
  '【重要要求】请用中文思考，思考过程不得使用英文。';

export function buildZzlChatUserContent(userText, aiText) {
  const parts = [ZZL_THINKING_PROMPT_HINT];
  if (userText && String(userText).trim()) {
    parts.push(String(userText).trim());
  }
  if (aiText && String(aiText).trim()) {
    parts.push(String(aiText).trim());
  }
  return parts.join('\n\n');
}

/** 导出 txt：提示词 + 数据（不含 AI 思考约束） */
export function buildZzlDataExportText(userText, aiText) {
  const prompt = userText == null ? '' : String(userText).trim();
  const data = aiText == null ? '' : String(aiText).trim();
  if (prompt && data) return `${prompt}\n\n${data}`;
  return prompt || data;
}

/** @returns {{ role: string, content: string }[]} */
export function buildZzlChatMessages(userText, aiText) {
  return [
    { role: 'system', content: ZZL_THINKING_SYSTEM_HINT },
    { role: 'user', content: buildZzlChatUserContent(userText, aiText) },
  ];
}

/** 强制输出纯 HTML 单页（无解释、无 Markdown 围栏） */
export const ZZL_HTML_SYSTEM_PROMPT = `${ZZL_THINKING_SYSTEM_HINT}

你是单文件 HTML 页面生成器。根据用户提供的业务数据与要求，生成【一个可独立运行的完整 HTML 网页】。

【硬性输出规则】
1. 回复内容必须且只能是完整 HTML 源码本身：从 <!DOCTYPE html> 开始，到 </html> 结束。
2. 禁止在 HTML 前后输出任何说明、标题、列表、总结、道歉或 Markdown。
3. 禁止使用 \`\`\`html 或任何代码围栏包裹。
4. 所有 CSS/JS 写在同一文件内（可用 <style>/<script>）；第三方库仅能通过国内可访问 CDN 引入。
5. 页面需美观、信息清晰、适配常见桌面宽度；数据用表格/卡片/图表等方式呈现。
6. 思考过程用中文（thinking），但最终可见输出只能是纯 HTML。`;

export function buildZzlHtmlChatUserContent(userText, aiText) {
  const parts = [
    '【任务】请根据下列数据生成完整可运行的单文件 HTML 报告页。',
    '【输出】只输出纯 HTML（<!DOCTYPE html>…</html>），不要任何其它文字或代码块标记。',
  ];
  if (userText && String(userText).trim()) {
    parts.push(`【页面要求】\n${String(userText).trim()}`);
  } else {
    parts.push('【页面要求】生成专业、清晰的数据报告页，含标题、摘要、关键指标与明细表格。');
  }
  if (aiText && String(aiText).trim()) {
    parts.push(`【业务数据】\n${String(aiText).trim()}`);
  }
  return parts.join('\n\n');
}

/** @returns {{ role: string, content: string }[]} */
export function buildZzlHtmlChatMessages(userText, aiText) {
  return [
    { role: 'system', content: ZZL_HTML_SYSTEM_PROMPT },
    { role: 'user', content: buildZzlHtmlChatUserContent(userText, aiText) },
  ];
}
